import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { keyUri, config } from "../../src/key";
import { toast } from "react-toastify";

const initialState = {
  currentTerms: null,
  loading: false,
  hasError: false,
};

export const termsSlice = createSlice({
  name: "terms",
  initialState,
  reducers: {
    getTermsRequest: (state) => {
      state.loading = true;
      state.hasError = false;
    },
    getTermsFailure: (state) => {
      state.loading = false;
      state.hasError = true;
    },
    getCurrentTermsSuccess: (state, { payload }) => {
      state.loading = false;
      state.currentTerms = payload;
    },
  },
});

export const {
  getTermsRequest,
  getTermsFailure,
  getCurrentTermsSuccess,
} = termsSlice.actions;

export const termsSelector = (state) => state.terms;


// Fetch terms and conditions by admin ID
export const fetchTermsByAdminId = (adminId) => async (dispatch) => {
  dispatch(getTermsRequest());
  try {
    const { data } = await axios.get(
      keyUri.BACKEND_URI + `/getTerms/${adminId}`,
      config
    );
    dispatch(getCurrentTermsSuccess(data));
  } catch (error) {
    dispatch(getTermsFailure());
    toast.error("Error fetching terms", { position: "top-center", autoClose: 2500 });
  }
}; 




export default termsSlice.reducer;
